import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import defaultRemoteConfig from "./default";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DB_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export const firebase = initializeApp(firebaseConfig);
export const remoteConfig = getRemoteConfig(firebase);
remoteConfig.settings.minimumFetchIntervalMillis = 0;
remoteConfig.defaultConfig = defaultRemoteConfig;
